// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3KCq-","additionalInfo":"AgreementModal_additionalInfo__mc_8j"};